import styled from 'styled-components';
import { ResponsiveFeatureImg } from 'components/ResponsiveImg';

const PostHeroImg = styled(ResponsiveFeatureImg)`
  height: 0;
  padding-bottom: 56%;
  overflow: hidden;
  position: relative;
  border-radius: 5px;
  img {
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

export default PostHeroImg;
